import service from '@/store/services/profile-service';

const state = {
  user: null,
  namespaced: true,
};

const mutations = {
  SET_RESOURCE: (state, user) => {
    state.user = user;
  }
};

const actions = {
  user({commit, dispatch}, params) {
    return service.get(params)
      .then((profile) => {
        commit('SET_RESOURCE', profile.list);
      });
  }
};

const getters = {
  user: state => state.user,
  userRoute: state => process.env.VUE_APP_API_BASE_URL + '/users/' + state.user.slug,
  avatar: state => 'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + state.user.avatar,
  grandfathered: state => state.user.grandfathered,
  is_grandfathered: state => state.user.is_grandfathered,
  affiliate: state => state.user.affiliate,
  enterprise: state => state.user.enterprise,
  enterprises: state => state.user.enterprises,
  enterpriseCreated: state => state.user.enterprise_created,
  coachingCreated: state => state.user.coaching_created,
  subBasic: (state, getters, rootState, rootGetters) => {
    const plans = [
      process.env.VUE_APP_STRIPE_BASIC,
      process.env.VUE_APP_STRIPE_STANDARD,
      process.env.VUE_APP_STRIPE_PREMIUM
    ];
    return plans.includes(state.user.subscription) || getters.is_grandfathered || getters.enterpriseCreated || getters.enterprises;
  },
  subStandard: (state, getters, rootState, rootGetters) => {
    const plans = [
      process.env.VUE_APP_STRIPE_STANDARD,
      process.env.VUE_APP_STRIPE_PREMIUM
    ];
    return plans.includes(state.user.subscription) || getters.is_grandfathered || getters.enterpriseCreated || getters.enterprises;
  },
  subPremium: (state, getters, rootState, rootGetters) => {
    const plans = [
      process.env.VUE_APP_STRIPE_PREMIUM
    ];
    return plans.includes(state.user.subscription) || getters.is_grandfathered || getters.enterpriseCreated || getters.enterprises;
  },
  fubIntegration: (state, getters, rootState, rootGetters) => {
    return state.integrations.includes('follow-up-boss');
  },
  coachingNow: (state, getters, rootState, rootGetters) => {
    return this.enterprise || this.enterpriseCreated || this.coachingCreated;
  }
};

const profile = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default profile;
